<template>
  <div class="loader">
    <div class="loader__value">{{ progress }}%</div>
    <svg class="loader__circular">
      <!--
        Радиус расчитывается в setup функции (в пикселях).
        Здесь он указан на случай если ref не сработает
      -->
      <circle ref="progressRef" class="loader__circular_progress" />
    </svg>
  </div>
</template>

<script>
import { shallowRef } from "@vue/reactivity";
import { onBeforeUnmount, onMounted } from "@vue/runtime-core";
import { vwToPx } from "@/utils/measurements";

export default {
  emits: ["finish"],
  setup(props, { emit }) {
    const vwRadius = 16;
    const speed = 0.4;
    const maxOffset = 2 * Math.PI * vwRadius;
    let offset = maxOffset;
    let interval = 120;
    let timeout = null;
    const progress = shallowRef(0);
    const progressRef = shallowRef(null);

    function setProgress() {
      if (progress.value < 50) {
        interval = 40;
      } else if (progress.value < 70) {
        interval = 60;
      } else if (progress.value < 95) {
        interval = 80;
      } else if (progress.value < 98) {
        interval = 100;
      }
      offset -= speed;
      timeout = setTimeout(() => {
        progress.value = parseInt(100 - (offset * 100) / maxOffset);
        if (progressRef.value) {
          progressRef.value.setAttribute("stroke-dashoffset", vwToPx(offset));
        }

        if (progress.value < 99) {
          setProgress();
        } else {
          emit("finish");
        }
      }, interval);
    }

    onBeforeUnmount(() => {
      if (timeout) clearTimeout(timeout);
    });

    onMounted(() => {
      requestAnimationFrame(() => {
        if (progressRef.value) {
          const outerRadius =
            parseFloat(getComputedStyle(progressRef.value.parentNode).width) /
            2;
          progressRef.value.setAttribute("r", vwToPx(vwRadius));
          progressRef.value.setAttribute("cx", outerRadius);
          progressRef.value.setAttribute("cy", outerRadius);
          progressRef.value.setAttribute("stroke-dashoffset", vwToPx(offset));
          progressRef.value.setAttribute("stroke-dasharray", vwToPx(offset));
          setTimeout(() => {
            progressRef.value.style.transition =
              "stroke-dashoffset 0.2s linear";
          }, 100);
        }
        setProgress();
      });
    });

    return {
      progress,
      progressRef,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.loader {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 140px;
  height: 140px;
  background-color: #fff;
  border-radius: 50%;
  transform: scale(1.1);

  &__value {
    font-family: Roboto-Bold;
    font-size: 40px;
    color: $colorRed;
    position: absolute;
  }

  &__circular {
    position: relative;
    width: 136px;
    height: 136px;

    &_progress {
      fill: none;
      stroke-linecap: round;
      transform: rotate(-90deg);
      transform-origin: 50% 50%;
      stroke-width: 2px;
      stroke: $colorRed;
    }
  }
}
</style>
